import { Container, AuthCard, StyledLink } from '../style';

const ForgotPassword = () => {
    return (
        <Container>
            <AuthCard title="Forgot Password">
                <p style={{ marginBottom: 16 }}>
                    Password reset for the e-documents portal will be available here soon.
                </p>
                <StyledLink to="/sign-in">Back to Sign In</StyledLink>
            </AuthCard>
        </Container>
    );
};

export default ForgotPassword;
